import React from "react";
interface IconProps {
    fill: string;
    class?: string;
    className?: string;
    height: number;
}


export const VertigoIcon = (props: IconProps) => (
    <svg fill={props.fill} className={props.class} viewBox="0 0 297 297" width={props.height} height={props.height} >
        <g>
            <path d="M293.048,273.311l-79.231-79.519c10.027-18.235,7.351-41.68-8.054-57.136l-14.713-14.758l20.756-20.8
	c5.287-5.299,5.278-13.881-0.02-19.168c-5.299-5.288-13.882-5.28-19.168,0.02l-9.55,9.57c2.366-19.316,10.245-45.091,32.963-67.888
	c4.435-4.45,5.23-11.365,1.922-16.705c-3.308-5.34-9.85-7.709-15.812-5.72c-1.878,0.627-36.015,12.308-61.767,39.933
	c0.432-7.377,2.059-14.506,5.31-21.03c2.63-5.278,1.546-11.652-2.683-15.763c-4.228-4.11-10.631-5.015-15.833-2.238
	c-1.569,0.838-32.951,18.24-38.293,68.327L58.929,40.391c-5.282-5.302-13.865-5.316-19.168-0.031
	c-5.302,5.284-5.315,13.867-0.031,19.168l32.144,32.249C26.11,99.34,4.293,124.414,3.212,125.69
	c-4.162,4.914-4.294,12.078-0.313,17.14s10.973,6.622,16.732,3.737c7.442-3.733,15.917-5.29,24.81-5.316
	c-28.854,23.192-42.436,59.205-43.177,61.213c-2.202,5.977,0.054,12.68,5.422,16.11c2.242,1.432,4.774,2.131,7.292,2.131
	c3.508,0,6.986-1.358,9.603-3.985c17.777-17.834,39.379-28.793,64.205-32.572c1.119-0.17,2.213-0.315,3.294-0.449l-7.805,7.821
	c-5.287,5.299-5.278,13.881,0.02,19.168c2.645,2.64,6.11,3.96,9.574,3.96c3.473,0,6.947-1.327,9.594-3.98l20.851-20.895
	l14.687,14.975c9.055,9.083,21.092,14.329,33.896,14.329c0.001,0,0.003,0,0.004,0c8.046,0,15.788-2.219,22.679-5.943l79.263,79.431
	c2.648,2.657,6.124,3.927,9.601,3.927c3.461,0,6.922-1.348,9.567-3.983C298.316,287.225,298.331,278.613,293.048,273.311z
	 M155.19,99.901c-3.122-6.311-6.179-13.395-8.707-20.86c4.484-8.925,10.635-16.609,17.368-23.123
	C157.844,72.34,155.695,87.715,155.19,99.901z M116.085,71.124c3.576,16.057,9.796,30.813,15.61,42.271l-15.926-15.978
	C114.888,87.425,115.11,78.699,116.085,71.124z M110.015,130.043c-9.792-4.351-25.443-8.187-37.514-11.209
	c6.09-0.968,17.035-2,24.263-2.085L110.015,130.043z M84.5,147.833c5.026,1.834,12.002,5.819,16.548,7.882
	c-11.017,0.349-24.846,2.036-39.778,6.829C68.106,157,75.722,149.962,84.5,147.833z M171.901,191.649
	c-5.547,0-10.767-2.254-14.699-6.199l-14.738-14.826l29.437-29.518l14.663,14.697c8.137,8.164,8.145,21.513,0.021,29.663
	c-3.927,3.938-9.141,6.182-14.682,6.182H171.901z"/>

        </g>

    </svg >
)


// WEBPACK FOOTER //
// ./src/layout/icons/Vertigo.tsx